module.exports = __webpack_public_path__ + "img/car_stopped.c905e6ea.svg";